/**
 * Pagina libreria drill. Solo guardia + Layout: i dati li carica
 * `ShootingDrillsTab`, secondo il pattern page-wrapper del repo.
 */
import { Navigate } from "react-router-dom";
import { Layout } from "../components/Layout";
import { useAuth } from "../contexts/AuthContext";
import { ShootingDrillsTab } from "../components/ShootingDrillsTab";
import { DOMAIN_SHOOTING, hasDomain } from "../lib/domainAccess";

export default function ShootingDrills() {
	const { user, loading } = useAuth();

	if (loading) return null;
	if (!user) return <Navigate to="/login" replace />;
	if (!hasDomain(user, DOMAIN_SHOOTING))
		return <Navigate to="/dashboard" replace />;

	return (
		<Layout>
			<div className="max-w-2xl mx-auto px-4 py-5 pb-28">
				<h1 className="font-heading text-2xl mb-4">Libreria drill</h1>
				<ShootingDrillsTab />
			</div>
		</Layout>
	);
}
